import React, { useState, useRef, useEffect } from "react";

const Dropdown = ({
  label,
  displayValue,
  children,
  getTypographyClass,
  placeholder = "Select",
  dropdownClassName = "",
  fieldClassName = "",
  fieldIcon,
  borderColor = "#dadada",
  onOpen,
  onClose,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const dropdownRef = useRef(null);

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsVisible(false);
        if (onClose) onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const handleToggle = () => {
    const newState = !isVisible;
    setIsVisible(newState);

    if (newState && onOpen) {
      onOpen();
    } else if (!newState && onClose) {
      onClose();
    }
  };

  return (
    <div className="tw:flex tw:flex-col tw:relative" ref={dropdownRef}>
      {label && (
        <div className={`tw:mb-2 tw:text-[#8d8d8d] ${getTypographyClass ? getTypographyClass(13) : "tw:text-[13px]"}`}>
          {label}
        </div>
      )}

      <div
        onClick={handleToggle}
        style={{ borderColor: borderColor }}
        className={`tw:relative tw:h-[50px] tw:rounded-[5px] tw:border tw:bg-white tw:px-[14px] tw:flex tw:items-center tw:cursor-pointer ${fieldIcon ? "tw:pl-[44px]" : ""} ${getTypographyClass ? getTypographyClass(14) : "tw:text-[14px]"} ${fieldClassName}`}
      >
        {fieldIcon && (
          <span className="tw:absolute tw:left-[14px] tw:top-1/2 tw:-translate-y-1/2 tw:flex tw:items-center tw:justify-center">
            {fieldIcon}
          </span>
        )}
        <span className="tw:text-[#282828]">
          {displayValue || placeholder}
        </span>
        <span className="tw:absolute tw:right-4 tw:top-1/2 tw:h-2 tw:w-2 tw:-translate-y-1/2 tw:rotate-45 tw:border-b-2 tw:border-r-2 tw:border-[#8d8d8d]" />
      </div>

      {isVisible && (
        <div className={`tw:absolute tw:top-full tw:left-0 tw:right-0 tw:mt-1 tw:bg-white tw:rounded-[5px] tw:border tw:border-[#e8e8e8] tw:shadow-lg tw:z-10 tw:p-4 ${dropdownClassName}`}>
          {children}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
